import React, { useEffect, useState, useContext } from 'react';
import Typography from '@material-ui/core/Typography';
import { useHistory } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import 'suneditor/dist/css/suneditor.min.css';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from "@material-ui/core/IconButton"
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';

import NewsContext from '../../context/news-context';
import { getNewsFilter, getNewsItems } from '../../actions/news-actions'
import useStyles from '../shared/defaultLayout/styles'
import useStylesNews from '../../styles/components/news/stylesNews'
import { getIconNews } from '../../utils/helpers/icon/iconHelper';

const NewsHeader = () => {
    const image = getIconNews().img_news_background;
    const classes = useStyles({ image });
    const styles = useStylesNews();
    const history = useHistory();
    const { newsContext, dispatch } = useContext(NewsContext);
    const [searchTerm, setSearchTerm] = useState('')
    const data = {
        page: 1,
        size: 5
    }

    useEffect(() => {
        if (window.location.pathname === '/NewsSearch') {
            if (newsContext !== undefined) {
                if (newsContext.searchTerm) {
                    setSearchTerm(newsContext.searchTerm)
                }
            }
        } else {
            setSearchTerm('')
        }
    }, [newsContext])

    const initNewsFilter = async () => {
        if (searchTerm) {
            const response = await getNewsFilter(searchTerm, data);
            if (response > 200 || response.status === "Failed") {
                return history.push("/SessionTimeOut")
            }

            dispatch({ type: 'SET_SEARCHTERM', searchTerm })
            dispatch({ type: 'SET_NEWS_LIST', newsList: response.data })
            dispatch({ type: 'SET_SEARCHPAGE', searchPage: data })
            history.push('/NewsSearch')

        }
        else {
            const response = await getNewsItems(data);
            if (response > 200 || response.status === "Failed") {
                return history.push("/SessionTimeOut")
            }

            dispatch({ type: 'SET_SEARCHTERM', searchTerm })
            history.push('/News')
        }
    }

    const handleChange = e => setSearchTerm(e.target.value)

    const handleSearch = () => initNewsFilter()

    const handleSubmit = e => {
        e.preventDefault()
        initNewsFilter()
    }

    return (
        <Grid container alignItems="center" justify="center" className={clsx(classes.defaultLayoutHeader, styles.layoutHeader)}>
            <Grid item md={7} sm={8} xs={10} container justify="center" direction="column">
                <Typography
                    classes={{ body1: classes.body1 }}
                    align="center"
                    className={clsx(classes.title, styles.rootGridNewsHeader)}>
                    News
                </Typography>
                <Grid item xs={12} container justify="center">
                    <form onSubmit={handleSubmit}>
                        <FormControl variant="outlined" fullWidth>
                            <TextField
                                margin="normal"
                                fullWidth
                                color="secondary"
                                variant="outlined"
                                classes={{ root: styles.rootTextField }}
                                InputLabelProps={{ shrink: false }}
                                label={!searchTerm ? "Search" : ""}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" classes={{ root: styles.rootInputAdornment }}>
                                            <IconButton onClick={handleSearch}>
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                onChange={handleChange}
                            />
                        </FormControl>
                    </form>
                </Grid>
            </Grid>
        </Grid>
    );
};

export { NewsHeader as default }